'use strict';

export const WorkletsModule = null;
//# sourceMappingURL=NativeWorklets.js.map